module.exports = __webpack_public_path__ + "img/check_circle.6bc7ef96.svg";